import React from "react";

function Corporate() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Corporate</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Advisory work is provided to clients across a wide range of markets.  Clients are mainly companies and corporations.
              </p>
              <p>
              Lawyers must pay attention to all sorts of issues in this area as it is crucial for a company to ensure the compatibility of its structure with all relevant laws.
              </p>
              <p>
              Corporate lawyers are involved with the setting up of companies along with advising on how a company should be run.  Corporate Lawyers also play a major role in the various transactions a company will take whether they involve flotation on the stock exchange, issuing securities or entering into private equity and venture capital transactions.
              </p>
              <p>
              We have so far created numerous companies for our clients.  Corporate clients form a substantial proportion of our client portfolio.  Most of our day to day work involves them and their needs.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Corporate;
